const CardBody = (props) => {
    const {className} = props;

    return (
        <div className={'card-body ' + className}>
            {props.children}
        </div>
    );
};


CardBody.defaultProps = {
    className: ''
}

export default CardBody;